import { useEffect, useRef, useState } from "react";

// Assets
import { Magnify, Phone, Envelope, Cam, PlayRecado } from "src/assets/svgs";

// Actions
import { doGetUserRequest } from "src/store/context/actions";

// Components
// import IcomBtn from "src/components/icom-btn";

type SearchUserState = {
  loading: boolean;
  userList: Array<any>;
  searchTerm: string;
  searchQuery: string;
  count: number;
};

function UserListItem({ user, index }: { user: any; index: number }) {
  const [state, setState] = useState({
    closed: true,
  });

  return (
    <li className="border-b pb-5 pt-5">
      <div aria-label="visible" className="flex items-start justify-between">
        <div>
          <span className="text-base text-neutral-gray-600 font-bold dark:text-white">
            {user.usuario.nome}
          </span>

          <small className="block text-sm text-neutral-gray-500 dark:text-white">
            {user.aderente.nome}
          </small>
        </div>
        <button
          className="text-sm underline decoration-1 text-neutral-gray-500"
          type="button"
          onClick={() => setState((s) => ({ ...s, closed: !s.closed }))}
        >
          {state.closed ? "Ver detalhes" : "Ocultar detalhes"}
        </button>
      </div>

      {!state.closed && (
        <div className="mt-3">
          <div className="infos flex gap-3 mb-5">
            <span className="flex items-center text-sm stroke-neutral-gray-500 text-neutral-gray-500 dark:text-white">
              <Envelope className="mr-1" /> {user.usuario.email}
            </span>

            <span className="flex items-center text-sm stroke-neutral-gray-500 text-neutral-gray-500 dark:text-white">
              <Phone className="mr-1" /> {user.usuario.celular}
            </span>
          </div>

          {/* <div className="actions flex gap-3">
            <IcomBtn onClick={() => alert("vrau")}>
              <Cam className="stroke-white mr-2" /> Chamada de vídeo
            </IcomBtn>

            <IcomBtn bordered onClick={() => alert("vrau")}>
              <PlayRecado className="stroke-primary-blue mr-2" /> Recado de
              vídeo
            </IcomBtn>
          </div> */}
        </div>
      )}
    </li>
  );
}

export default function SearchUsers() {
  let typeInterval = useRef<null | ReturnType<typeof setTimeout>>(undefined);

  const [state, setState] = useState<SearchUserState>({
    loading: false,
    userList: [],
    count: 0,
    searchTerm: "nome",
    searchQuery: "",
  });

  useEffect(() => {
    if (state.searchQuery !== "") {
      // Clear interval
      setState((s) => ({ ...s, loading: true }));

      typeInterval.current && clearInterval(typeInterval.current);

      typeInterval.current = setTimeout(() => {
        search(state.searchTerm, state.searchQuery);
      }, 500);
    } else {
      setState((s) => ({ ...s, userList: [], count: 0 }));
    }

    async function search(searchTerm: string, searchQuery: string) {
      const { data, success } = await doGetUserRequest(searchTerm, searchQuery);

      if (success) {
        setState((s) => ({
          ...s,
          userList: [...data.results],
          count: data.count,
          loading: false,
        }));
      } else {
        setState((s) => ({ ...s, loading: false }));
      }
    }
  }, [state.searchQuery, state.searchTerm]);

  return (
    <div className="min-h-0 flex flex-col" data-testid="search-users-side">
      <h2 className="dark:text-neutral-gray-50 text-2xl font-semibold mb-6">
        Buscar usuários
      </h2>

      {/* Search input */}
      <div className="flex gap-4 mb-4">
        <input
          type="text"
          className="rounded-md border grow p-3 px-4 dark:border-neutral-gray-700 dark:bg-neutral-gray-700 dark:text-neutral-gray-50 text-gray-900"
          placeholder="Digite o nome do usuário"
          value={state.searchQuery}
          onChange={(e) =>
            setState((s) => ({ ...s, searchQuery: e.target.value }))
          }
        />
        <button
          type="submit"
          className="px-5 py-3 dark:bg-primary-blue-400 bg-primary-blue-500 rounded-md stroke-white"
        >
          <Magnify />
        </button>
      </div>

      {/* Radios filter */}
      <div className="flex font-semibold dark:text-neutral-gray-50 text-neutral-gray-500 mb-5">
        <span className="mr-3">Filtrar por: </span>
        <label htmlFor="filter_name" className="mr-4">
          <input
            className="mr-2"
            type="radio"
            name="filter"
            value="name"
            id="filter_name"
            checked={state.searchTerm === "nome"}
            onChange={() => setState((s) => ({ ...s, searchTerm: "nome" }))}
          />
          <span>Nome</span>
        </label>

        <label htmlFor="filter_phone">
          <input
            className="mr-2"
            type="radio"
            name="filter"
            value="phone"
            id="filter_phone"
            checked={state.searchTerm === "celular"}
            onChange={() => setState((s) => ({ ...s, searchTerm: "celular" }))}
          />
          <span>Telefone</span>
        </label>
      </div>

      {/* Loading */}
      {state.loading ? (
        <div className="flex items-center text-base justify-center h-[200px] text-primary-blue-500 font-bold dark:text-white">
          <span className="loader spinner-1 mr-2"></span> Carregando
        </div>
      ) : (
        <>
          {/* User list */}
          {state.userList.length > 0 && (
            <div className="flex flex-col min-h-0">
              <h3 className="text-base text-neutral-gray-400 font-semibold">
                {state.count} resultados encontrados
              </h3>

              <ul className="overflow-x-auto">
                {state.userList.map((user, index) => (
                  <UserListItem key={index} user={user} index={index} />
                ))}
              </ul>
            </div>
          )}

          {state.userList.length === 0 && (
            <div className="flex items-center text-base justify-center h-[200px] text-neutral-gray-400 text-center font-semibold">
              Não encontramos nenhum resultado. <br /> Vamos tentar de novo?
            </div>
          )}
        </>
      )}
    </div>
  );
}
